<template>
  <div class="mt-component-form">
    <vs-row class="my-4 ">
      <h5 style="align-self: center"><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint && !isReadonly"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow">항목추가</vs-button>
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <!-- row -->
    <div
      class="grid mb-6"
      :style="{gridTemplateColumns : `${isPrint || isReadonly ? '' : '36px'} 1fr`}"
      v-for="(row, indexRow) in equipmentList"
      :key="indexRow"
    >
      <div v-if="!isPrint && !isReadonly" class="none-border-center th write361">
        <vs-checkbox v-model="row.is_checked"></vs-checkbox>
      </div>
      <div>
        <!--첫번째 줄-->
        <div class="grid" style="grid-template-columns: 1fr 1fr 1fr 1fr 1fr;">
          <div class="th">검진일<br/>/ 검진병원</div>
          <div class="th">구분</div>
          <div class="th">검진소견</div>
          <div class="th">사후관리조치</div>
          <div class="th">{{ determinationLabel }}</div>

          <div class="td">
            <div style="margin-bottom: 7px;">
              <date-selector class="w-full" v-model="row['검진일']" placeholder="날짜" :readonly="isReadonly || isPrint"></date-selector>
            </div>
            <div>
              <ml-input v-model="row['검진병원']" class="w-full" />
            </div>
          </div>

          <div class="td">
            <ml-input v-model="row['구분']" class="w-full" />
          </div>
          <div class="td">
            <ml-textarea v-model="row['검진소견']" class="w-full h-full" height="100%" />
          </div>
          <div class="td">
            <ml-textarea v-model="row['사후관리조치']" class="w-full h-full" height="100%" />
          </div>
          <div class="td">
            <vs-select :disabled="isReadonly || isPrint" v-model="row['판정']" autocomplete class="w-full flex-1">
              <vs-select-item v-for="option of determinationOptions" :text="option" :value="option" :key="option" />
            </vs-select>
          </div>
        </div>

        <!--두번째 줄-->
        <div class="grid" style="grid-template-columns: repeat(7, 1fr);">
          <div class="th" style="grid-row: 1/3">상담기준</div>
          <div class="th">고혈압</div>
          <div class="th">당뇨</div>
          <div class="th">이상지질혈증</div>
          <div class="th">간장질환</div>
          <div class="th">기타</div>
          <div class="th">기저질환</div>
          <div class="td">
            <ml-input v-model="row['상담기준.고혈압']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['상담기준.당뇨']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['상담기준.이상지질혈증']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['상담기준.간장질환']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['상담기준.기타']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['상담기준.기저질환']" class="w-full" />
          </div>
        </div>

        <!--세번째 줄-->
        <div class="grid" style="grid-template-columns: repeat(16, 1fr);">
          <div class="th" style="grid-row: 1/3">1차</div>
          <div class="th">BP</div>
          <div class="th">청력</div>
          <div class="th">AST(GOT)</div>
          <div class="th">ALT(GPT)</div>
          <div class="th">GPT</div>
          <div class="th">TC</div>
          <div class="th">TG</div>
          <div class="th">HDL</div>
          <div class="th">요다백</div>
          <div class="th">urine OB</div>
          <div class="th">혈당</div>
          <div class="th" style="grid-column: span 2">흉부방사선</div>
          <div class="th" style="grid-column: span 2">폐기능</div>
          <div class="td">
            <ml-input v-model="row['1차.BP']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.청력']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.AST']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.ALT']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.GPT']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.TC']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.TG']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.HDL']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.요다백']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.urine OB']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['1차.혈당']" class="w-full" />
          </div>
          <div class="td" style="grid-column: span 2">
            <ml-input v-model="row['1차.흉부방사선']" class="w-full" />
          </div>
          <div class="td" style="grid-column: span 2">
            <ml-input v-model="row['1차.폐기능']" class="w-full" />
          </div>
        </div>


        <div class="grid" style="grid-template-columns: repeat(16, 1fr);">
          <div class="th" style="grid-row: 1/3">2차</div>
          <div class="th">BP</div>
          <div class="th">청력</div>
          <div class="th">AST(GOT)</div>
          <div class="th">ALT(GPT)</div>
          <div class="th">GPT</div>
          <div class="th">TC</div>
          <div class="th">TG</div>
          <div class="th">HDL</div>
          <div class="th">LDL</div>
          <div class="th">혈당</div>
          <div class="th">당화혈색소</div>
          <div class="th">BUN</div>
          <div class="th">Cr</div>
          <div class="th">흉부방사선</div>
          <div class="th">폐기능</div>
          <div class="td">
            <ml-input v-model="row['2차.BP']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.청력']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.AST']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.ALT']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.GPT']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.TC']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.TG']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.HDL']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.LDL']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.혈당']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.당화혈색소']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.BUN']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.Cr']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.흉부방사선']" class="w-full" />
          </div>
          <div class="td">
            <ml-input v-model="row['2차.폐기능']" class="w-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: 'Table361GeneralCheckup',
  components: {DateSelector},
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    title: {
      type: String,
      default: '일반 검진'
    },
    determinationLabel: {
      type: String,
      default: '건강진단 건간관리구분 판정'
    },
    determinationOptions: {
      type: Array,
      default: () => ['C2', 'D2']
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.equipmentList = value
        }
      },
    },
    equipmentList: {
      handler() {
        this.updateList();
      }
    }
  },
  methods: {
    checkForm (value, indexRow, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRow - 1, text)
      } else {
        this.$emit('update-list-check', indexRow - 1, '')
      }
    },
    // 항목추가
    handleAddRow () {
      this.equipmentList.push({})
      this.updateList()
    },
    // 선택삭제
    handleRemoveRow () {
      for (let i = 0; i < this.equipmentList.length; i++) {
        if (this.equipmentList[i].is_checked) {
          this.equipmentList.remove(this.equipmentList[i])
          i = -1
        }
      }

      this.equipAllCheck = false
      this.updateList()
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck
      }
    },
    // update
    updateList () {
      this.$emit('updateList', this.equipmentList)
    },
  },
  data () {
    return {
      equipAllCheck: false,
      equipmentList: [],
    }
  },
}
</script>
<style>
.write361 .vs-checkbox {
  margin-right: 0 !important;
}
</style>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
.th {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  background-color: #f9f9f9;
  outline: $border;
  text-align: center;
}
.td {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 7px;
  outline: $border;
}
</style>
